module.exports = __webpack_public_path__ + "img/article_10_4.8f9e4cf6.png";